import { z } from 'zod';

import {
  ADDRESS_ALLOWED_CHARACTERS_REGEX,
  PO_BOX_REGEX,
} from './streetAddressLineOne.schema';

export const streetAddressLineTwoValidationMessages = {
  invalid_po_box: `Can't be a PO box.`,
  invalid_characters: "Use only letters, numbers, spaces, #, -, /, ., ', and &",
};

export const streetAddressLineTwoSchema = z
  .string()
  .regex(ADDRESS_ALLOWED_CHARACTERS_REGEX, {
    error: streetAddressLineTwoValidationMessages.invalid_characters,
  })
  .refine((value) => !PO_BOX_REGEX.test(value), {
    message: streetAddressLineTwoValidationMessages.invalid_po_box,
  });
